<template>
    <div>
      <b-card>
        <b-row>
          <b-col cols="auto" class="mr-auto">
              
            <!--
              <b-form-group>
                  <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
            -->
          </b-col>
          <b-col cols="auto" class="">
            <b-form-group>
              <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Enviar Arquivos</span></b-button>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="auto">
            <b-form-group>
                <label for="period" style="font-size: 0.8em">Período</label>
                <b-form-select id="period"
                  v-model="filters.period"
                  :plain="true"
                  :options="periodDDL"
                  @change="refreshData"
                  :value="[null,'c']">
                </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="auto">
            <b-form-group>
                <label for="movementType" style="font-size: 0.8em">Tipo de Movimento</label>
                <b-form-select id="movementType"
                  v-model="filters.movementTypeId"
                  :plain="true"
                  :options="movementTypeDDL"
                  @change="refreshData"
                  :value="[null,'c']">
                </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="auto">
            <b-form-group>
                <label for="name" style="font-size: 0.8em">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
          </b-col>
      
          <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
              <p></p>
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
          </b-col>

          <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage">Linhas</label>
                <b-form-select v-model="table.perPage" id="perPage"
                  :plain="true"
                  :options="[5,10,20,50,100]">
                </b-form-select>
              </b-form-group>
          </b-col>
          
        </b-row>
    
        <b-table
            :items="filteredItems"
            :fields="table.fields"
            :select-mode="table.selectMode"
            responsive="sm"
            ref="selectableTable"
            selectable
            :primary-key="table.primaryKey"
            :tbody-transition-props="table.transProps"
            sort-icon-left
            :busy="table.isBusy"
            hover
            striped
            >

            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
            </template>
            
            <!-- Example scoped slot for select state illustrative purposes -->
            <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">Not selected</span>
                </template>
            </template>
            
            <template v-slot:cell(date)="data">
                {{ $utils.refDateToStringFormat(data.item.referenceDate) }}
            </template>

            <template v-slot:cell(movementValue)="data">
              <span class="text-danger" v-show="data.item.movementTypeId == 2">
                <b>-{{ $utils.numberFormat(data.item.movementValue) }}</b>
              </span>
              <span v-show="data.item.movementTypeId != 2">
                <b>{{ $utils.numberFormat(data.item.movementValue) }}</b>
              </span>
            </template>
        
            <!--
            <template v-slot:cell(st)="data">
                <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
            </template>
            
            <template v-slot:cell(ispublic)="data">
                <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
            </template>
            -->

         
            <template #custom-footer="{ items }">
              <p>Total Items: {{ items.length }}</p>
            </template>
        </b-table>
       
        <p></p>

        <nav>
            <b-pagination :total-rows="totalRows" :per-page="table.perPage" v-model="table.currentPage" prev-text="Anterior" next-text="Próximo" />
        </nav>
      </b-card>


      <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Enviar Arquivos"
            size="md">
      <accounts-payable-files-component></accounts-payable-files-component>

    </b-modal>

    </div>
</template>

<script>

import axios from "axios";
import AccountsPayableFilesComponent from "./AccountsPayableFilesComponent.vue";

export default {
  name: "AccountsPayableFiles",
  components: {
    AccountsPayableFilesComponent
  },
  props: {
    userId: 0,
    accountId: 0
  },
  data() {
    return {
      editModal: false,
      drawValue: null,     
      items: [],
      itemsBalance: [],
      itemsRequest: [],
      periodDDL: [
        { value: 15, text: '15 dias' },
        { value: 30, text: '30 dias' },
        { value: 60, text: '60 dias' }
      ],
      movementTypeDDL: [ 
        { value: 0, text: '- Todos ' },
        { value: 1, text: 'Entrada' },
        { value: 2, text: 'Saída' }
      ],

      filters: {
        key: '',
        period: 30,
        movementTypeId: 0
      },

      table: {
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          {key: 'date', label: 'Data', sortable: false, thStyle: { width: "150px" }  },
          {key: 'name', label: 'Descrição', sortable: false },
          //{key: 'balance', label: 'Saldo', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
          //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          {key: 'movementValue', label: 'Valor', sortable: false, class: 'text-right', thStyle: { width: "150px" }},
          //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          //{key: 'description', label: 'Descrição', sortable: false },
          //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
          //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
          //{key: 'st', label: 'Status', sortable: false, thStyle: { width: "40px" } }
        ],
        selectMode:'single',
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        currentPage: 1,
        perPage: 100,
        primaryKey: "id",
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        isBusy: false,
      },

      tableRequest: {
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          {key: 'date', label: 'Data', sortable: false, thStyle: { width: "150px" }  },
          {key: 'name', label: 'Descrição', sortable: false },
          //{key: 'balance', label: 'Saldo', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
          //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          {key: 'movementValue', label: 'Valor', sortable: false, class: 'text-right', thStyle: { width: "150px" }},
          //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          //{key: 'description', label: 'Descrição', sortable: false },
          //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
          //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
          //{key: 'st', label: 'Status', sortable: false, thStyle: { width: "40px" } }
        ],
        selectMode:'single',
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        currentPage: 1,
        perPage: 100,
        primaryKey: "id",
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        isBusy: false,
      },

    }
  },
  computed: {
    propUserId() {
      if(!this.userId) return 0
      return this.userId
    },
    propAccountId() {
      if(!this.accountId) return 0
      return this.accountId
    },
    
    totalRows: function() { return this.getRowCount() },

    filteredItems: function() {
          var list = this.items.filter(item => {
              return ((this.filters.key == '' || item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                && ( this.filters.movementTypeId == 0 || item.movementTypeId == this.filters.movementTypeId )
              )
            })

          list = list.map(item => {
              if(item.movementTypeId == 2)
                item._rowVariant = 'danger'
              return item
          })

          if(this.itemsBalance && this.itemsBalance.length >= 2) {
            if(list.length > 0)
              list.unshift({ referenceDate: this.itemsBalance[0].referenceDate, name: 'Saldo anterior', movementValue: this.itemsBalance[0].balance, movementTypeId: 1, _rowVariant: 'primary' })
            list.push({ referenceDate: this.itemsBalance[1].referenceDate, name: 'Saldo atual', movementValue: this.itemsBalance[1].balance, movementTypeId: 1, _rowVariant: 'primary' })
          }
          
          return list
      }
  },
  methods: {
    getVariant (status) {
      switch (status) {
        case 1:
          return 'success'
        case 1:
          return 'danger'
        default:
          return 'active'
      }
    },

    getRowCount: function() {
        return this.items.length
    },

    requestDraw() {

    },

    openEditModal() {
      this.editModal = true
    },

    async refreshRequest() {
      var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
          this.$store.state.ws_url + "/finance/account/movement?userId=" + currentUser.id + "&statusId=4&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
            s.itemsRequest = resp.data.obj;
        })
        .catch(function(error) {
            console.log(error);
        });
    },

    async refreshData() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
          this.$store.state.ws_url + "/finance/account/balance?accountId=" + this.propAccountId + "&userId=" + this.propUserId + "&days=" + this.filters.period + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
            s.itemsBalance = resp.data.obj;
        })
        .catch(function(error) {
            console.log(error);
        });

        await axios.get(
            this.$store.state.ws_url + "/finance/account/movement?accountId=" + this.propAccountId + "&userId=" + this.propUserId + "&days=" + this.filters.period + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
            s.items = resp.data.obj;
        })
        .catch(function(error) {
            console.log(error);
        });
       
    }
   
  },
  mounted: function() {
    this.refreshData()
  }
  
};

</script>
